<template>
  <div>
    <div>
      <div class="c-card-body">
        <datatable
          ref="datatable"
          module="member"
          :title="title"
          :url="url"
          :columns="columns"
          :on-click-create="onClickCreate"
          :on-click-update="onClickUpdate"
          :on-click-delete="onClickDelete"
          :action-width="180"
          :filter="filter"
        >
          <template
            v-if="canEdit && !loading"
            v-slot:action
          >
            <v-col md="3">
              <v-btn
                depressed
                class="ma-1"
                color="primary"
                small
                @click="onClickCreate()"
              >
                <v-icon small left>mdi-plus</v-icon>
                Tambah
              </v-btn>
            </v-col>
          </template>
          <template v-slot:item.roles="{ item }">
            {{ item.roles_name.join(", ") }}
          </template>
        </datatable>
      </div>
    </div>
    <form-member-progress ref="formMemberProgress" :success="formSuccess" />
    <delete-dialog
      ref="delete"
      url="member-progress"
      :success="deleteSuccess"
    ></delete-dialog>
  </div>
</template>

<script>
import Datatable from "@/view/component/Datatable.vue";
import DeleteDialog from "@/view/component/DeleteDialog.vue";
import FormMemberProgress from "./FormMemberProgress.vue";

export default {
  data() {
    return {
      title: "Member Progress",
      url: "member-progress/data?id=" + this.id,
      columns: [
        {
          value: "id"
        },
        {
          text: "Weight",
          value: "weight",
          sortable: false,
          searchable: true
        },
        {
          text: "Height",
          value: "height",
          sortable: false,
          searchable: true
        },
        {
          text: "BMI",
          value: "bmi",
          sortable: false,
          searchable: true
        },
        {
          text: "Body Fat Percentage",
          value: "body_fat_percentage",
          sortable: false,
          searchable: true
        },
        {
          text: "Muscle Mass",
          value: "muscle_mass",
          sortable: false,
          searchable: true
        },
        {
          text: "Body Water Percentage",
          value: "body_water_percentage",
          sortable: false,
          searchable: true
        },
       
        
      ],
      data: [],
      loading: true,
      filter: null
    };
  },
  props: {
    id: String,
    canEdit: Boolean
  },
  methods: {
    onClickCreate() {
      this.$refs.formMemberProgress.open(this.id);
    },
    onClickUpdate(item) {
      this.$refs.formMemberProgress.open(this.id, item.id);
    },
    onClickDelete(item) {
      this.$refs.delete.open(item.id);
    },
    formSuccess() {
      this.$refs.datatable.getData();
    },
    deleteSuccess() {
      this.$refs.datatable.getData();
    },
    setDefaultFilter() {
      this.filter = [
        {
          column: "member_id",
          value: this.id,
          operator: "eq",
        },
      ];
    },
  },
  mounted() {
    this.setDefaultFilter();
    this.$watch(
      () => {
        return this.$refs.datatable.items;
      },
      val => {
        this.data = val;
        this.loading = false;
      }
    );
  },
  components: {
    Datatable,
    DeleteDialog,
    FormMemberProgress
  }
};
</script>
